<template>
  <view class="toptitle">
    <view class="topleft">
      <img src="@/assets/home/icon.png" alt="">
      <text> {{title}} </text>
    </view>
  </view>
</template>
<script>
export default {
  name: 'titleColor',
  data () {
    return {
    //   title: ''
    }
  },
  props: {
    title: String
  }
}
</script>

<style lang="scss">
.toptitle{
      /* margin-left: 24px; */
  .topleft {
    display: flex;
    align-items: center;
    height: 36px;
    img{
      width: 24px;
      height: 24px;
    }
    text {
      color: #001b51;
      font-size: 24px;
      font-weight: 500;
      line-height: 36px;
      margin-left: 8px;
    }
  }
    }
</style>
